
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'phone-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input-value'],

	data() {
		return {
			tel: ''
		};
	},

	methods: {
		inputValue() {
			if (!this.tel) return;
			this.$emit('input-value', this.tel);
			this.tel = '';
		}
	}
});
